import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { IconUI } from './IconUI';
import React, { useState } from 'react';
import { VerticalLayoutUI } from './VerticalLayout';
import { TextUI } from './Text';
import { HorizontalLayoutUI } from './HorizontalLayout';

export type AccordionGroupProps = {
  items: Array<{
    label: string
    endAdornment?: React.ReactNode
    content: React.ReactNode
  }>
};

export const AccordionGroupUI: React.FC<AccordionGroupProps> = ({ items }) => {
  const [openId, setOpenId] = useState<number | undefined>(undefined);
  return (
    <VerticalLayoutUI>
      {items.map(({ label, content, endAdornment }, i) => (
        <Accordion
          key={i}
          expanded={openId === i}
          onChange={() => setOpenId(openId === i ? undefined : i)}
          disableGutters
          style={{
            // boxShadow: 'none'
          }}
        >
          <AccordionSummary expandIcon={<IconUI name="keyboard_arrow_down" />}>
            <HorizontalLayoutUI justify="space-between" align="center" width="100%">
              {label}
              {endAdornment}
            </HorizontalLayoutUI>
          </AccordionSummary>
          <AccordionDetails>
            {content}
          </AccordionDetails>
        </Accordion>

      ))}
    </VerticalLayoutUI>
  );
};
